<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm9 md6 lg4>
      <loading-state v-if="tokenIsValid === null" />
      <v-card v-else class="RequestPasswordResetCard">
        <v-card-title primary-title class="RequestPasswordResetCard-title">
          <img src="/images/logo_text.png" alt="logo explorama" />
          <p v-if="tokenIsValid && !hasValidate">
            {{ $t('resetPassword.subtitle') }}
          </p>
          <v-alert
            v-else-if="!hasValidate"
            type="error"
            :value="true"
            outline
            >{{ $t('resetPassword.tokenError') }}</v-alert
          >
          <v-alert type="success" :value="hasValidate" outline>
            <span>{{ $t('resetPassword.success') }}</span>
            <a class="block" href="/login">{{
              $t('resetPassword.goToLogin')
            }}</a>
          </v-alert>
        </v-card-title>
        <v-form
          v-if="tokenIsValid && !hasValidate"
          @submit.prevent="doResetPassword"
          id="RequestResetPasswordForm"
          ref="form"
        >
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="password"
                  :rules="getPasswordRules()"
                  :label="$t('accountCreation.password')"
                  :type="showPasswords ? 'text' : 'password'"
                  :append-icon="showPasswords ? 'visibility' : 'visibility_off'"
                  @click:append="showPasswords = !showPasswords"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  v-model="confirmPassword"
                  :rules="getConfirmPasswordRules()"
                  :label="$t('accountCreation.confirmPassword')"
                  :type="showPasswords ? 'text' : 'password'"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-alert type="error" :value="errorMessage" outline>{{
                  errorMessage
                }}</v-alert>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn
              color="primary"
              type="submit"
              form="RequestResetPasswordForm"
              class="RequestPasswordResetCard-LoginBtn"
              >{{ $t('requestResetPassword.submitLabel') }}</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import LoadingState from '../components/LoadingState';

export default {
  name: 'ResetPassword',
  components: {
    LoadingState,
  },
  data() {
    return {
      token: '',
      tokenIsValid: null,
      password: '',
      confirmPassword: '',
      errorMessage: '',
      showPasswords: false,
      hasValidate: false,
    };
  },
  async beforeMount() {
    this.token = this.$route.params.token;

    try {
      const res = await this.$kuzzle.query({
        controller: 'reset-password',
        action: 'checkToken',
        body: {
          token: this.token,
        },
      });
      this.tokenIsValid = res.result;
    } catch (e) {
      this.errorMessage = e.message;
      console.error(e.message);
    }
  },
  methods: {
    getPasswordRules() {
      return [
        (password) =>
          Boolean(password) ||
          this.$t('accountCreation.errors.passwordRequired'),
      ];
    },
    getConfirmPasswordRules() {
      return [
        (confirmPassword) =>
          Boolean(confirmPassword) ||
          this.$t('accountCreation.errors.confirmPasswordRequired'),
        (confirmPassword) =>
          confirmPassword === this.password ||
          this.$t('accountCreation.errors.mustBeIdentical'),
      ];
    },
    async doResetPassword() {
      this.hasValidate = false;
      this.errorMessage = '';
      if (!this.$refs.form.validate()) {
        return;
      }
      try {
        await this.$kuzzle.query({
          controller: 'reset-password',
          action: 'reset',
          body: {
            token: this.token,
            password: this.password,
          },
        });
        this.hasValidate = true;
      } catch (e) {
        this.errorMessage = e.message;
        console.error(e.message);
      }
    },
  },
};
</script>

<style scoped lang="sass">
.RequestPasswordResetCard
  &-title
    img
      width: 25em
      margin-bottom: 2em
  &-LoginBtn
    margin: 0

.block
  display: block
</style>
